import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import GDLogo from '@ux/gd-logo';
import PLLogo from '@ux/pl-logo';

/**
 * Renders shared GD or reseller logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
function Logo(props) {
  var _window$ux;
  /** @type {?Object} */
  // eslint-disable-next-line no-undefined
  var uxData = typeof window === 'undefined' ? undefined : (_window$ux = window.ux) === null || _window$ux === void 0 ? void 0 : _window$ux.data;
  var defaultProps = _objectSpread({
    collapsedLogo: false,
    // Do not use `ux.data.countryName` since this should be empty except for when we use this in the headers and are in
    // specific markets
    country: '',
    market: (uxData === null || uxData === void 0 ? void 0 : uxData.market) || 'en-US',
    privateLabelId: (uxData === null || uxData === void 0 ? void 0 : uxData.privateLabelId) || 1,
    privateLabelName: uxData === null || uxData === void 0 ? void 0 : uxData.privateLabelName,
    logos: uxData === null || uxData === void 0 ? void 0 : uxData.logos,
    showCountryNameOnLogo: false,
    urlArgs: {}
  }, props);
  return defaultProps.privateLabelId === 1 ? /*#__PURE__*/React.createElement(GDLogo, defaultProps) : /*#__PURE__*/React.createElement(PLLogo, defaultProps);
}
Logo.propTypes = {
  /** CSS class name to apply to the outer element */
  'className': PropTypes.string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': PropTypes.bool,
  /** Current country name. */
  'country': PropTypes.string,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': PropTypes.string,
  /** href to pass to Link component */
  'href': PropTypes.string,
  /** An object with desktop and mobile reseller logo source links */
  'logos': PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string
  }),
  /** GoDaddy Airo only: Logo variant selector */
  'logoVariant': PropTypes.oneOf(['fullColor', 'monochrome']),
  /** Current market */
  'market': PropTypes.string,
  /** Callback for a click on the logo link */
  'onClick': PropTypes.func,
  /** The private label ID */
  'privateLabelId': PropTypes.number,
  /** The reseller's private label name shown under the logo image or when no logos provided */
  'privateLabelName': PropTypes.string,
  /** if true, and not US market, country label on logo will be generated */
  'showCountryNameOnLogo': PropTypes.bool,
  /** CSS class name to apply to outer `figure` element */
  'figClass': PropTypes.string,
  /** An object with specifications for a temporary alternate logo */
  'tempLogo': PropTypes.shape({
    filename: PropTypes.string,
    start: PropTypes.object,
    end: PropTypes.object,
    styles: PropTypes.object,
    altText: PropTypes.string
  }),
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': PropTypes.object,
  /** An object with urls from rootProps including the CDN url for a temporary logo */
  'urls': PropTypes.shape({
    cdn: PropTypes.shape({
      href: PropTypes.string
    })
  })
};
export default Logo;